import { Pipe, PipeTransform } from '@angular/core';
import { element } from 'protractor';

@Pipe({
  name: 'CambioNombrePorId'
})
export class NombrePorIdCatalogoPipe implements PipeTransform {


  transform(id: number, catalogo: any[], nodoEntrada:any, nodoSalida:any ): string | number {
    // console.log(id,catalogo,nodoEntrada,nodoSalida);
    if (!id || !nodoEntrada || !nodoSalida) return '';
    if (!catalogo?.length) return '';
    
    let encontrado = catalogo.find(element => element[nodoEntrada] === id);
    if (!encontrado) return 'Valor no encontrado';
    if (!encontrado[nodoSalida]) return 'Valor no encontrado'; 
    
    return encontrado[nodoSalida] 
  } 
}